module.exports = __webpack_public_path__ + "img/9788973819928.b33e5ecc.jpg";